// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3zje7","vertical":"Radio_vertical__3jUS-"};